import React from "react";
import styles from "./RSVPSend.module.css";
import { SubmitButton, TextComponent } from "../../../../../components";
import {
  CalendarIcon,
  ClockIcon,
  LocIcon,
  UserIcon,
} from "../../../../../components/icons/Icons";
import { List } from "antd";
import { GoDot, GoDotFill } from "react-icons/go";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import moment from "moment";
const RSVPSend = () => {
  const EventDetails = useSelector((state) => state.EventReducer.EventDetails);
  const RSVP = useSelector((state) => state.EventPlanningReducer.RSVP);
  const navigate = useNavigate();
  const dummyTidbitsList = [
    {
      id: 1,
      tidbits:
        "Share how you know the couple, wish them well or some wisdom for the future!",
    },
    {
      id: 2,
      tidbits: "What is your favorite activity together?",
    },
    {
      id: 3,
      tidbits: "Will you be able to Join us at our wedding?",
    },
  ];
  const renderItem = (item, index) => {
    return (
      <div className={styles.listItem}>
        <GoDotFill className={styles.dot} />
        <TextComponent
          text={item?.question ? item?.question : item?.name}
          textClass={styles.TB_text}
        />
      </div>
    );
  };
  return (
    <div className={styles.mainCont}>
      <div
        className={styles.EditRsvp}
        onClick={() =>
          navigate("/events/RSVPDetails", {
            state: { headrTitle: "RSVP" },
          })
        }
      >
        <TextComponent text={"Edit RSVP"} />
      </div>
      <div className={styles.detailsDiv}>
        <div className={styles.details}>
          <TextComponent
            text={"Wedding details"}
            textClass={styles.detailsHeading}
          />
          <div className={styles.subDetails}>
            <div className={styles.subLeft}>
              <LocIcon size={20} className={styles.locationIcon} />
              <TextComponent text={"Location:"} />
            </div>
            <div className={styles.subright}>
              <TextComponent text={EventDetails?.address} />
            </div>
          </div>
          <div className={styles.subDetails}>
            <div className={styles.subLeft}>
              <CalendarIcon size={20} className={styles.locationIcon} />
              <TextComponent text={"Date:"} />
            </div>
            <div className={styles.subright}>
              <TextComponent
                text={moment(EventDetails?.date).format("MMMM DD, yyyy")}
              />
            </div>
          </div>
          <div className={styles.subDetails}>
            <div className={styles.subLeft}>
              <UserIcon size={20} className={styles.locationIcon} />
              <TextComponent text={"Guests:"} />
            </div>
            <div className={styles.subright}>
              <TextComponent
                text={`${EventDetails?.no_of_attendee}/${EventDetails?.no_of_guest}`}
              />
            </div>
          </div>
          <div className={styles.subDetails}>
            <div className={styles.subLeft}>
              <ClockIcon size={20} className={styles.locationIcon} />
              <TextComponent text={"Start Time"} />
            </div>
            <div className={styles.subright}>
              <TextComponent
                text={moment(EventDetails?.start_time).format("hh:mm a")}
              />
            </div>
          </div>
        </div>
        <div className={styles.details}>
          <TextComponent
            text={"Reception details"}
            textClass={styles.detailsHeading}
          />
          <div className={styles.subDetails}>
            <div className={styles.subLeft}>
              <LocIcon size={20} className={styles.locationIcon} />
              <TextComponent text={"Location:"} />
            </div>
            <div className={styles.subright}>
              <TextComponent text={EventDetails?.reception_address} />
            </div>
          </div>
          <div className={styles.subDetails}>
            <div className={styles.subLeft}>
              <CalendarIcon size={20} className={styles.locationIcon} />
              <TextComponent text={"Date:"} />
            </div>
            <div className={styles.subright}>
              <TextComponent
                text={moment(EventDetails?.date).format("MMMM DD, yyyy")}
              />
            </div>
          </div>
          <div className={styles.subDetails}>
            <div className={styles.subLeft}>
              <UserIcon size={20} className={styles.locationIcon} />
              <TextComponent text={"Guests:"} />
            </div>
            <div className={styles.subright}>
              <TextComponent
                text={`${EventDetails?.no_of_attendee}/${EventDetails?.no_of_guest}`}
              />
            </div>
          </div>
          <div className={styles.subDetails}>
            <div className={styles.underDetails}>
              <div className={styles.subLeft}>
                <ClockIcon size={20} className={styles.locationIcon} />
                <TextComponent text={"Start Time"} />
              </div>
              <div className={styles.subright}>
                <TextComponent
                  text={moment(EventDetails?.reception_start_time).format(
                    "hh:mm a"
                  )}
                />
              </div>
            </div>
            <div className={styles.underDetails}>
              <div className={styles.subLeft}>
                <ClockIcon size={20} className={styles.locationIcon} />
                <TextComponent text={"End Time"} />
              </div>
              <div className={styles.subright}>
                <TextComponent
                  text={moment(EventDetails?.reception_end_time).format(
                    "hh:mm a"
                  )}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <TextComponent text={"Tidbits "} textClass={styles.TB_Heading} />
      <List
        dataSource={RSVP?.tidbits?.length > 0 ? RSVP?.tidbits : []}
        className={styles.list}
        renderItem={renderItem}
      />
      <div className={styles.TB_Heading_Meals}>
        <TextComponent text={"Meals"} textClass={styles.TB_Heading} />
      </div>
      <List
        dataSource={RSVP?.meals?.length > 0 ? RSVP?.meals : []}
        className={styles.list}
        renderItem={renderItem}
      />
      <div className={styles.btnDiv}>
        <SubmitButton
          title="Send RSVP"
          btnClass={styles.btn}
          onClick={() => navigate("/events/RSVPGuest")}
        />
      </div>
    </div>
  );
};

export default RSVPSend;
